import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerLocationID } from "models";

type ReorderChecklistPayload = {
  checklist_id: ChecklistID;
  location_id: DealerLocationID;
  display_order: number;
};

export const useReorderChecklistMutation = () =>
  useTypedMutation<ReorderChecklistPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/order/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ checklist_id, location_id, display_order }) => {
      const locationChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(location_id));
      if (!locationChecklists?.length) return;

      const checklistIdx = locationChecklists.findIndex(lc => lc.id === checklist_id);
      if (checklistIdx === -1) return;

      const previousDisplayOrder = locationChecklists[checklistIdx].display_order;

      typedQueryClient.setQueryData(
        ChecklistsDashboardQueryKeys.locationChecklists(location_id),
        locationChecklists.map(lc => {
          if (lc.id === checklist_id) return { ...lc, display_order };
          if (lc.display_order === display_order) return { ...lc, display_order: previousDisplayOrder };
          return lc;
        })
      );
    }
  });
